// extracted by mini-css-extract-plugin
export default {"container":"FeeLine-module__container","static":"FeeLine-module__static","details":"FeeLine-module__details","detailsIcon":"FeeLine-module__detailsIcon"};